import { useNavigate } from "react-router-dom";
import Buttons from "../Components/Buttons";
import React, { useCallback, useEffect, useRef, useState } from "react";
import Chart from "chart.js/auto";
import axios from "axios";
import { baseUrl } from "../constant";
import ChartDataLabels from "chartjs-plugin-datalabels";
import toast, { Toaster } from "react-hot-toast";
import { FcInfo } from "react-icons/fc";
import serviceFunctions from "../Services";
import Notiflix from "notiflix";
import { handleTokenExpiry } from "../Helper";

export default function SpinWheel() {
  const [userData, setUserdata] = useState({});
  const [tapToSpin, setTapToSpin] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [prize, setPrize] = useState([]);
  const [prizes, setPrizes] = useState([]);
  const [isSpinning, setIsSpinning] = useState(false);
  const [isAudioPlaying, setIsAudioPlaying] = useState(false);
  const [countdown, setCountdown] = useState(0);
  const [showCountdown, setShowCountdown] = useState(false);
  const [btnDisable, setBtnDisable] = useState(false);
  const [prizeId, setPrizeId] = useState(66);
  const audioRef = useRef(new Audio("spinsound.m4a"));
  const [sound, setSound] = useState(true);
  const [availableSpin, setAvailableSpin] = useState(0);
  const [alreadyFetchedUserProfile, setAlreadyFetchedUserProfile] =
    useState(false);
  const [winAmount, setWinAmount] = useState("");

  const navigate = useNavigate();
  const wheelRef = useRef(null);
  const spinBtnRef = useRef(null);
  const stopBtnRef = useRef(null);
  const myChartRef = useRef(null);
  const finalPrizeRef = useRef(null);
  const wonAudioRef = useRef(new Audio("/images/wonaudio.mp3"));
  const [showGif, setShowGif] = useState(false);
  const gifRef = useRef(null);

  let token = localStorage.getItem("token");

  // const handleVisibilityChange = useCallback(() => {
  //   if (document.hidden) {
  //     audioRef.current.muted = true;
  //   } else {
  //     audioRef.current.muted = false;
  //     if (isAudioPlaying && sound) {
  //       audioRef.current.play().catch((err) => console.log(err));
  //     }
  //   }
  // }, [isAudioPlaying, sound]);

  // useEffect(() => {
  //   const token = localStorage.getItem("token");
  //   setToken(token);
  //   const mysound = localStorage.getItem("sound");
  //   setSound(mysound ? mysound : true);

  //   document.addEventListener("visibilitychange", handleVisibilityChange);

  //   return () => {
  //     document.removeEventListener("visibilitychange", handleVisibilityChange);
  //   };
  // }, [handleVisibilityChange]);

  const startCountdown = (seconds) => {
    setCountdown(seconds);
    setShowCountdown(true);

    const interval = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    setTimeout(() => {
      clearInterval(interval);
      setCountdown(0);
      setShowCountdown(false);
      setBtnDisable(false);
    }, seconds * 1000);
    setBtnDisable(true);
  };

  const allPrize = useCallback(async () => {
    Notiflix.Loading.circle(); // Moved loading indicator to the start
    try {
      const response = await axios.get(`${baseUrl}/admin/fetch-prizes-list`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const userNetwork = localStorage.getItem("network");
      const networkData = response.data.data.prizes.find(
        (network) => network.network === userNetwork
      );

      if (networkData) {
        const prizes = [{ prizeAmount: "N0.00", prizeId: 0 }].concat(
          networkData.prizes.map((prize) => ({
            prizeAmount: `N${prize.prizeAmount}`,
            prizeId: prize.prizeId,
          }))
        );

        const prizeAmounts = prizes.map((prize) => prize.prizeAmount);
        setPrizes(prizes);
        setPrize(prizeAmounts);
        setTapToSpin(true);
      } else {
        // Notiflix.Notify.info(`No prizes found for ${userNetwork}`);
      }
    } catch (err) {
      console.error("Error fetching prizes:", err);
      Notiflix.Notify.info("Please check your internet connection");
      if (err?.response?.status === 401) {
        serviceFunctions.handleLogout();
      }
    } finally {
      Notiflix.Loading.remove(); // Ensure loading is removed in all cases
    }
  }, [token, setPrizes, setPrize, setTapToSpin]); // Added dependencies

  const initializeChart = useCallback(() => {
    if (myChartRef.current) {
      myChartRef.current.destroy();
    }

    const data = Array(prize.length).fill(100 / prize.length);
    const pieColors = [
      "#faa621",
      "#e65051",
      "#39a0e8",
      "#2eae74",
      "#c93c77",
      "#b163da",
    ].slice(0, prize.length);

    myChartRef.current = new Chart(wheelRef.current, {
      plugins: [ChartDataLabels],
      type: "pie",
      data: {
        labels: prizes.map((e) => e.prizeAmount),
        datasets: [
          {
            backgroundColor: pieColors,
            data: data,
            borderWidth: 0,
          },
        ],
      },
      options: {
        responsive: true,
        animation: { duration: 0 },
        plugins: {
          tooltip: false,
          legend: { display: false },
          datalabels: {
            rotation: (ctx) => {
              const valuesBefore = ctx.dataset.data
                .slice(0, ctx.dataIndex)
                .reduce((a, b) => a + b, 0);
              const sum = ctx.dataset.data.reduce((a, b) => a + b, 0);
              const rotation =
                ((valuesBefore + ctx.dataset.data[ctx.dataIndex] / 2) / sum) *
                360;
              return rotation < 180 ? rotation - 90 : rotation + 90;
            },
            color: "#ffffff",
            formatter: (_, ctx) => ctx.chart.data.labels[ctx.dataIndex],
            font: { weight: "bold", size: 15 },
          },
        },
        elements: {
          arc: {
            borderWidth: 0,
          },
        },
      },
    });
  }, [prize, prizes]);

  const valueGenerator = (angleValue, targetPrizeId) => {
    if (!prizes || prizes.length === 0) return;

    const smallestPrizeId = Math.min(...prizes.map((e) => e.prizeId));
    const rotationValues = prizes.map((_, i) => {
      const minDegree = i * (360 / prize.length);
      const maxDegree = (i + 1) * (360 / prize.length) - 1;
      return {
        minDegree,
        maxDegree,
        value: prizes[i].prizeAmount,
        prizeId: prizes[i].prizeId,
      };
    });

    const wonPrize = rotationValues.find((el) => el.prizeId === targetPrizeId);

    if (targetPrizeId === smallestPrizeId) {
      setShowGif(false);
      setTimeout(() => setShowGif(false), 2500);
      return;
    } else if (wonPrize?.prizeId > 0) {
      if (sound) {
        wonAudioRef.current.play().catch((err) => console.log(err));
      }
      setShowGif(true);
      setTimeout(() => setShowGif(false), 2500);
      finalPrizeRef.current = `${wonPrize?.prizeId}`;
    }
  };

  const spinBtnClickHandler = () => {
    if (!tapToSpin || isButtonDisabled) return;

    setIsButtonDisabled(true);
    setIsSpinning(true);
    // finalValueRef.current.innerHTML = "";
    setWinAmount("");

    const wheel = document.getElementById("wheel");
    wheel.style.transition = "none";
    wheel.style.transform = "rotate(0deg)";
    void wheel.offsetWidth; // Force reflow

    axios
      .post(
        `${baseUrl}/user/spin-wheel`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((response) => {
        setAvailableSpin((prev) => prev - 1);
        if (response.data.statusCode === 201) {
          spinTrackerHandler();
        }
      })
      .catch((error) => {
        toast.error(error.response?.data?.message || "Spin failed", {
          duration: 3000,
        });
        setIsSpinning(false);
        setIsButtonDisabled(false);
      });
  };

  const handleAudioClick = () => {
    if (isAudioPlaying) {
      audioRef.current.pause();
    } else if (sound) {
      audioRef.current.currentTime = 0;
      audioRef.current.play().catch((err) => console.log(err));
    }
    setIsAudioPlaying(!isAudioPlaying);
  };

  const spinTrackerHandler = () => {
    axios
      .get(`${baseUrl}/user/spin-tracker`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const winAmountFromApi = response?.data?.data?.win_amount ?? 0;

        const targetPrizeId =
          response?.data?.data?.prize_id ||
          Math.min(...prizes.map((e) => e.prizeId));
        setPrizeId(targetPrizeId);
        setIsSpinning(false);

        const targetRotation = calculateTargetRotation(targetPrizeId, prizes);

        const rotatingDeg = 360 * 20 + targetRotation;
        console.log(targetRotation, targetPrizeId, prizes, rotatingDeg);

        const wheel = document.getElementById("wheel");
        wheel.style.transition =
          "transform 7s cubic-bezier(0.17, 0.67, 0.21, 0.99)";
        wheel.style.transform = `rotate(${rotatingDeg}deg)`;

        if (sound && !isAudioPlaying) {
          handleAudioClick();
        }

        setTimeout(() => {
          valueGenerator(targetRotation, targetPrizeId);
          setWinAmount(`N ${winAmountFromApi}`);
          setIsButtonDisabled(false);

          if (targetPrizeId !== Math.min(...prizes.map((e) => e.prizeId))) {
            Notiflix.Notify.success(
              `Congratulations You Won ${response?.data?.data?.win_amount}N`
            );
          } else {
            Notiflix.Notify.success("Better luck next time.");
          }
        }, 7000);
      })
      .catch((error) => {
        console.error(error);
        setIsSpinning(false);
        setIsButtonDisabled(false);
      });
  };

  const calculateTargetRotation = useCallback(
    (targetPrizeId = 0, prize_len) => {
      if (!prize_len) return 0;
      console.log(prizes);
      const index = prizes.findIndex((e) => e.prizeId === targetPrizeId);
      const initialRotation = 330; // Starting angle for index 1
      const reductionPerIndex = 60; // Reduction in degrees per index

      // Calculate rotation based on the index
      const rotation = initialRotation - index * reductionPerIndex;
      return rotation;
    },
    [prizes]
  );

  const handleStopSpin = (degrees) => {
    if (isSpinning) {
      startCountdown(7);
      setBtnDisable(true);

      const wheel = document.getElementById("wheel");
      wheel.style.transition =
        "transform 7s cubic-bezier(0.17, 0.67, 0.21, 0.99)";
      wheel.style.transform = `rotate(${degrees}deg)`;

      setTimeout(() => {
        valueGenerator(degrees, prizeId);
        setIsSpinning(false);
      }, 7000);

      const toggleAudio = () => {
        if (isAudioPlaying) {
          audioRef.current.pause();
        } else if (sound) {
          audioRef.current.play().catch((err) => console.log(err));
        }
        setIsAudioPlaying(!isAudioPlaying);
      };
      toggleAudio();
    }
  };

  const handleSound = () => {
    if (!isSpinning) {
      const newSound = !sound;
      setSound(newSound);
      localStorage.setItem("sound", newSound);
      if (!newSound) {
        audioRef.current.pause();
        setIsAudioPlaying(false);
      }
    }
  };

  const userProfile = useCallback(async () => {
    try {
      const response = await axios.get(`${baseUrl}/user/get-user`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setUserdata(response.data.data);
      setAvailableSpin(response.data.data.user_spins.available_spins);
      localStorage.setItem("network", response.data.data.user.network);
      localStorage.setItem("mobile", response.data.data.user.mobile_number);
      setAlreadyFetchedUserProfile(true);
    } catch (error) {
      handleTokenExpiry(error.response.data, () => {
        navigate("/login");
      });
      if (error?.response?.status === 401) {
        serviceFunctions.handleLogout();
      }
      console.error("Error fetching user profile:", error);
    }
  }, [
    token,
    setUserdata,
    setAvailableSpin,
    setAlreadyFetchedUserProfile,
    navigate,
  ]);

  useEffect(() => {
    initializeChart();
  }, [token, prize, initializeChart]);

  useEffect(() => {
    const fetchData = async () => {
      Notiflix.Loading.circle();
      try {
        // Array of functions that return promises
        const promiseFactories = [userProfile, allPrize];
        for (let i = 0; i < promiseFactories.length; i++) {
          await promiseFactories[i](); // Call the function and await its promise
        }
      } catch (error) {
        // Optional: Handle any errors from the promises
        console.error("Error during sequential data fetching:", error);
      } finally {
        Notiflix.Loading.remove();
      }
    };

    fetchData();
  }, [token, allPrize, alreadyFetchedUserProfile, userProfile]);

  useEffect(() => {
    if (availableSpin !== 0 && !alreadyFetchedUserProfile) {
      userProfile();
    }
  }, [availableSpin, alreadyFetchedUserProfile, userProfile]);

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) {
      console.warn("Audio element ref is not available.");
      return;
    }

    const handleAudioEnded = () => {
      setIsAudioPlaying(false);
      console.log("Audio finished playing.");
    };

    // Add the onended event listener
    audio.addEventListener("ended", handleAudioEnded);

    return () => {
      // Remove the onended event listener on cleanup
      audio.removeEventListener("ended", handleAudioEnded);
    };
  }, [audioRef, setIsAudioPlaying]);

  return (
    <>
      <div className="spinWheel">
        <Toaster />
        {showGif && (
          <div className="winnerGif">
            <img ref={gifRef} src="/images/winning.gif" alt="Winning GIF" />
          </div>
        )}
        <div className="wallet d-flex justify-content-center">
          <div
            className={`profileName ${
              isSpinning || btnDisable ? "unclickable" : ""
            }`}
            onClick={() => !(isSpinning || btnDisable) && navigate("/profile")}
          >
            <img
              src={userData.avatar ? userData.avatar : "images/avatar.png"}
              className="profile"
              alt="Profile"
            />
            <small>Profile</small>
          </div>
          <div className="gamelogo">
            <img src="images/logoimg.png" alt="Game Logo" />
          </div>
          <div
            onClick={() => !(isSpinning || btnDisable) && navigate("/help")}
            className={`spinhelp ${
              isSpinning || btnDisable ? "unclickable" : ""
            }`}
          >
            <FcInfo />
            <small>Info</small>
          </div>
        </div>

        <div className="content spin-wheel-myrow">
          <div
            className={`logobox ${
              isSpinning || btnDisable ? "unclickable" : ""
            }`}
            onClick={handleSound}
          >
            {sound ? (
              <img src="images/audio.png" alt="Audio On" />
            ) : (
              <img src="images/audio-off.png" alt="Audio Off" />
            )}
            <small>Sound</small>
          </div>
          <div className="winnerPrize">
            <strong>
              <i>
                <span>{winAmount}</span>
              </i>
            </strong>
          </div>
          <div
            className={`wallet_name ${
              isSpinning || btnDisable ? "unclickable" : ""
            }`}
            onClick={() =>
              !(isSpinning || btnDisable) && navigate("/my-wallet")
            }
          >
            <img src="images/wallet.gif" alt="Wallet" className="walletimg" />
            <small>Cashout</small>
          </div>
        </div>

        <div className="fullwheel mb-2">
          <div className="containers">
            <div className="box mc-rotate-box">
              <canvas ref={wheelRef} id="wheel"></canvas>
              <img
                src="images/spinner.png"
                alt="Spinner"
                className="spinners"
              />
              <img
                src="images/wheelwidth.png"
                alt="Wheel Outer"
                className="wheelouter"
              />
            </div>
          </div>
        </div>
        <div className="spinscount">
          <p>Available Spin: {availableSpin}</p>
        </div>
        <div className="spinWheelBtn">
          {showCountdown && (
            <div className="text-center">Next Spin: 00:0{countdown}</div>
          )}

          <button
            ref={spinBtnRef}
            value="Tap to Spin"
            className={`btn btn-info mb-1 tapping ${
              !tapToSpin ? "btn-tap-disable" : ""
            }`}
            onClick={spinBtnClickHandler}
            disabled={isButtonDisabled || !tapToSpin}
          >
            Tap to Spin
          </button>

          <button
            value="Stop Spin"
            className="btn btn-warning mb-1 tapping"
            ref={stopBtnRef}
            disabled={!isSpinning}
            onClick={() => handleStopSpin(0)}
          >
            Stop Spin
          </button>

          <Buttons
            value="Buy more spin"
            className={`btn btn-success mb-3 ${
              isSpinning || btnDisable ? "unclickable" : ""
            }`}
            onClick={() =>
              !(isSpinning || btnDisable) && navigate("/buy-spins")
            }
          />
        </div>
      </div>
    </>
  );
}
